import iconRightArrow from '@image/icon_arrow_right.svg';
import { BaseComponent } from './baseComponent';

export class RecruiterInfoWindowListItem extends BaseComponent {
  static readonly tagName = 'recruiter-info-window-list-item';
  static readonly checkAttributes = ['title', 'has-offer', 'link'];

  constructor(params?: {
    title?: string;
    hasOffer?: boolean;
    link?: string
  }) {
    super();
    if (params?.title) {
      this.setAttribute('title', params.title);
    }

    if (params?.hasOffer) {
      this.setAttribute('has-offer', params.hasOffer.valueOf() ? 'true' : 'false');
    }

    if (params?.link) {
      this.setAttribute('link', params.link);
    }
  }

  protected reader() {
    const title = this.getAttribute('title') || '';
    const hasOffer = this.getAttribute('has-offer') === 'true';
    const link = this.getAttribute('link') || '#';

    let hasOfferHtml = ``;

    if (hasOffer) {
      hasOfferHtml = `
        <div class="w-fit flex min-h-6 px-2 py-0.5 bg-primary rounded-[4px] justify-center items-center overflow-hidden text-center text-white font-semibold text-xs">
          求人あり
        </div>
      `.trim();
    }

    this.classList.add('flex', 'pt-4', 'pb-2');

    this.innerHTML = `
      <a tabindex="-1" class="text-lightblack w-full flex items-stretch" data-turbo-frame="_top" href="#">
        <div class="flex min-w-0 flex-1 flex-col justify-start gap-y-1">
          <span class="text-sm"></span>
          ${hasOfferHtml}
        </div>
        <div class="ml-auto flex w-8 shrink-0 items-center justify-end">
          <img src="${iconRightArrow}" class="h-5 w-5 object-contain">
        </div>
      </a>
    `.trim();
    this.querySelector('span')!.textContent = title;
    this.querySelector('a')!.setAttribute('href', link);
  }
}
